<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 59.1 (86144) - https://sketch.com -->
    <title>Icons/fleches/outline/ic_arrow_right</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Icons/fleches/outline/ic_arrow_right-"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        id="ic_arrow_next"
        d="M14.4888567,12.0007943 L5.51961293,3.02996192 C4.82679569,2.33714469 4.82679569,1.21243016 5.51961293,0.519612927 C6.21243016,-0.173204309 7.33714469,-0.173204309 8.02996192,0.519612927 L18.2551745,10.7448255 L17.6024354,11.3975646 L18.2551745,10.7448255 C18.9479917,11.4376427 18.9479917,12.5623573 18.2551745,13.2551745 L8.02996192,23.4803871 C7.33714469,24.1732043 6.21243016,24.1732043 5.51961293,23.4803871 C4.82679569,22.7875698 4.82679569,21.6628553 5.51961293,20.9700381 L14.4888567,12.0007943 Z"
        fill="white"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ArrowRight",
}
</script>
